import { api_base } from '../api';
import { router } from '../../routes/routes';
import * as types from '../mutation-types';
import Store from '../store';
import {
	getShoppingCart,
	getWishList,
	setBillingInfo,
	getorders,
	logoutUser
} from '../actions';

export const Orders = {
	// ---- GET ALL ----

	get(page = 1, data, cb) {
		$.ajax({
			url: api_base + '/admin/purchaseOrders?page=' + page,
			method: 'GET',
			headers: {
				Authorization: 'Bearer ' + data.token
			},
			
			success: function (res) {
				cb(res.data);

				if (res.next_page_url) {
					Orders.get(++page, data , cb);
				}
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				// console.log(err, data);
			}
		});
	},

	// ---- GET USER ORDERS ----

	getMe(user, cb) {
		$.ajax({
			url: api_base + '/users/me/orders',
			method: 'GET',
			headers: {
				Authorization: 'Bearer ' + user.token
			},

			success: function (res) {
				cb(res);
				// console.log(res);
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				if (err.status == 401) {
					logoutUser(Store, '/home');
					toast({
						title: 'Sesión Expirada',
						content: 'Inicia sesión de nuevo.'
					});
				}

				// console.log(err);
			}
		});
	},

	// ---- GET USER PURCHASE ORDERS ----

	getMePurchase(user, cb) {
		$.ajax({
			url: api_base + '/users/me/purchaseOrders',
			method: 'GET',
			headers: {
				Authorization: 'Bearer ' + user.token
			},

			success: function (res) {
				cb(res);
				// console.log(res);
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				if (err.status == 401) {
					logoutUser(Store, '/home');
					toast({
						title: 'Sesión Expirada',
						content: 'Inicia sesión de nuevo.'
					});
				}

				// console.log(err);
			}
		});
	},

	// ---- GET BY ID ----

	getById(user, id, cb) {
		let orders = Store.state.purcharse_orders || [];

		if (!orders.length) {
			$.ajax({
				url: api_base + '/users/me/purchaseOrders/' + id,
				method: 'GET',
				headers: {
					Authorization: 'Bearer ' + user.token
				},

				success: function (res) {
					cb(res);
				},

				error: function (err) {
					if (err.status == 500) {
						return toast({
							title: 'Servidor',
							content: 'Problemas con el servidor.'
						});
					}

					if (err.status == 401) {
						logoutUser(Store, '/home');
						toast({
							title: 'Sesión Expirada',
							content: 'Inicia sesión de nuevo.'
						});
					}

					// console.log(err);
				}
			});
		} else {
			for (let i = 0, o = orders; i < o.length; i++) {
				if (o[i].payment_id == id) {
					return o[i];
				}
			}
		}
	},

	// ---- DELETE ----

	delete(data, order, cb) {
		$.ajax({
			url: api_base + '/admin/purchaseOrders/' + order.id,
			method: 'DELETE',
			headers: {
				Authorization: 'Bearer ' + data.token
			},

			success: function (res) {
				cb(res);
			},

			error: function (err) {
				if (err.status == 401) {
					logoutUser(Store, '/home');
					toast({
						title: 'Sesión Expirada',
						content: 'Inicia sesión de nuevo.'
					});
				}

				// console.log(err);
			}
		});
	},

	// ---- UDPATE ----

	update(data, order, cb) {
		$.ajax({
			url: api_base + '/admin/purchaseOrders/' + order.id,
			method: 'PUT',
			data: order,
			headers: {
				Authorization: 'Bearer ' + data.token
			},

			success: function (res) {
				cb(res);
			},

			error: function (err) {
				if (err.status == 401) {
					logoutUser(Store, '/home');
					toast({
						title: 'Sesión Expirada',
						content: 'Inicia sesión de nuevo.'
					});
				}

				// console.log(err);
			}
		})
	},

	// ---- DELIVERED ----

	checkPaid(user, order, cb) {
		$.ajax({
			url: api_base + '/admin/purchaseOrders/' + order.id + '/checkAsPaid',
			method: 'GET',
			headers: {
				'Authorization': 'Bearer ' + user.token
			},

			success: function (res) {
				cb(res);
			},

			error: function (err) {
				if (err.status == 401) {
					logoutUser(Store, '/home');
					toast({
						title: 'Sesión Expirada',
						content: 'Inicia sesión de nuevo.'
					});
				}

				// console.log(err);
			}
		});
	},

	delivered(user, delivered, cb) {
		delivered._method = 'PUT';

		$.ajax({
			url: api_base + '/admin/purchaseOrders/' + delivered.id,
			method: 'POST',
			data: delivered,
			headers: {
				'Authorization': 'Bearer ' + user.token,
				'Accept': 'application/json'
			},

			success: function (res) {
				// console.log(res);
			},

			error: function (err) {
				if (err.status == 401) {
					logoutUser(Store, '/home');
					toast({
						title: 'Sesión Expirada',
						content: 'Inicia sesión de nuevo.'
					});
				}
				
				// console.log(err);
			}
		});
	}
};


// WEBPACK FOOTER //
// ./src/store/api/orders.js